var categoryBlog = {
    categoryList: function () {
        let btnSeeMore = $('.js-blog-see-more__button');
        let btntext = $('.c-blog-see-more__button-text');
        let item = $('.c-blog-categories-list__item.is-hidden');

        btnSeeMore.on('click', function () {
            if (screen && screen.width < 701) {
                item.toggleClass('is-visible')
                btntext.text('See less categories')
            }
        })
    }
}

$(function () {

    if ($('.c-blog').length) {
        categoryBlog.categoryList();
    }
})
